import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Discrepancy } from '../../models/discrepancy';

@Component({
    selector: 'rs-discrepancy-diff',
    templateUrl: './rs-discrepancy-diff.component.html',
    styleUrls: ['./rs-discrepancy-diff.component.scss'],
    standalone: false
})
export class DiscrepancyDiffComponent implements OnChanges {
    @Input() discrepancies: Discrepancy[];
    @Input() headers: any[]
    @Input() hideDiscovered = false

    public rows: any[] = [];
    public tableHeaders: any[] = [];

    constructor() {}

    public async ngOnInit() {
        this.rows = this.discrepancies
        this.tableHeaders = this.headers
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.details?.currentValue) {
            const payload = changes.details?.currentValue;
            this.rows = payload?.rows ?? [];
            this.tableHeaders = payload?.headers ?? [];
        }
    }
}

@NgModule({
    imports: [CommonModule, TranslateModule.forChild()],
    declarations: [DiscrepancyDiffComponent],
    exports: [DiscrepancyDiffComponent],
})
export class DiscrepancyDiffModule {}